<script setup>
import {computed} from 'vue'
import {useNavigationStore} from '@/stores/navigation'
import {useUserStore} from '@/stores/user'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    groupName: String,
    closeMenu: Function,
})

const appStore = useAppStore()
const navigationStore = useNavigationStore()
const userStore = useUserStore()

const components = computed(() => {
    return navigationStore.components.filter((obj) => {
        return obj.navigationGroup === props.groupName
    })
})

const user = computed(() => userStore.user)

const setActiveGroupName = (groupName) => {
    navigationStore.openGroupName = navigationStore.openGroupName === groupName ? undefined : groupName
}

const goToComponent = (tableName) => {
    window.location = '/#/' + tableName
    props.closeMenu()
}

const showComponent = (tableName) => {
    return (
        user.value?.administrator ||
        userStore.access(tableName)
    )
}
</script>

<template>
    <a v-show="components && components.length" class="list-group-item px-2" href
       @click.prevent.stop="setActiveGroupName(groupName)">
        <div class="ps-2">{{ groupName }}</div>

        <div
            :class="{
                'd-none': navigationStore.openGroupName !== groupName,
                'active d-block': navigationStore.openGroupName === groupName
            }"
            class="list-group mt-2"
        >
            <a v-for="component in components" :key="component.id" v-show="showComponent(component.tableName)"
               :class="{
                   'active': component.tableName === appStore.navigationComponent
               }"
               class="list-group-item px-2" role="menuitem" tabindex="-1" @click="goToComponent(component.tableName)">
                {{ component.title }}
            </a>
        </div>
    </a>
</template>